export default "__VITE_ASSET__DYIKc_IV__"